import Container from '@/components/container/Container';
import { SpanLink } from '@/components/text/Texts';
import styles from './terms-of-use.module.css';

const TermsOfUseCheckboxLabel = () => {
	return (
		<Container className="pl-4">
			<p className="text-body-medium text-sm font-poppins text-primary">
				I agree to the Xpress for Business{' '}
				<SpanLink
					className={styles.linkStyle}
					link="https://www.xpress.ph/terms"
					target="_blank"
					text="Terms of Use"
				/>
				and{' '}
				<SpanLink
					className={styles.linkStyle}
					link="https://www.xpress.ph/privacy-policy"
					target="_blank"
					text="Privacy Policy"
				/>
			</p>
		</Container>
	);
};

export default TermsOfUseCheckboxLabel;
